import { useEffect } from "react";
import L from "leaflet";
import "./AutoDriveLegend.css";
import { useAppContext } from "../libs/contextLib";
import ByLines from '../data/Techno_A2_LINK.json'

let dom_el = null;

function AutoDriveLegend({ map, carInfo }) {
  const { routeAppContext, setRouteAppContext } = useAppContext();
  const { carAppContext, setCarAppContext } = useAppContext();

  useEffect(() => {
    if (map && (routeAppContext.id == carInfo.data.route_id) && (carAppContext.vehicle_id == carInfo.data.vehicle_id)) {
      if (dom_el) {
        L.DomUtil.remove(dom_el);
        dom_el = null;
      }
      const info = L.control({ position: "topleft" });

      info.onAdd = () => {
        info._div = L.DomUtil.create("div", "info");
        dom_el = info._div;
        info.update(carInfo);
        return info._div;
      };

      info.update = (props) => {
        const ctrl = props.control;
        info._div.innerHTML =
          "<p style='color:black;font-size:20px'>차량주행정보</p><hr>" +
          (props
            ? "<b style='color:green;font-size:15px'>차량ID: " + props.data.vehicle_id + "</b><br />" +
            "<b style='color:red;font-size:15px'>속도: " + props.data.speed + "</b><br />" +
            "<b>latitude: " + props.data.latitude + "</b><br />" +
            "<b>longitude: " + props.data.longitude + "</b><br />" +
            "<b>heading: " + props.data.heading + "</b><br />" +
            "<b>autoModeStart: " + props.data.autoModeStart + "</b><br />" +
            "<b>trvlDist: " + props.data.trvlDist + "</b><br />" +
            "<b>autoTrvlDist: " + props.data.autoTrvlDist + "</b><br />" +
            "<hr>" +
            "<b>mode_car_status: " + (ctrl?.mode_car_status ?? "-") + "</b><br />" +
            "<b>service_car_status: " + (ctrl?.service_car_status ?? "-") + "</b><br />" +
            "<b>user_booking_status: " + (ctrl?.user_booking_status ?? "-") + "</b><br />" +
            "<b>user_booking_id: " + (ctrl?.user_booking_id ?? "-") + "</b><br />"
            : "차량정보가 없습니다.");
      };

      info.addTo(map);
    } else {
      if (dom_el) {
        L.DomUtil.remove(dom_el);
        dom_el = null;
      }
    }
  }, [map, carInfo, routeAppContext.id, carAppContext.vehicle_id]);

  return null;
}

export default AutoDriveLegend;